import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";


const TopInfracciones = ({ estadisticas }) => {
    const { loads } = useGeneralAppStore();

    const colors = [
        "#dc3545",
        "#c83552",
        "#b4355f",
        "#a0356c",
        "#8c357a",
        "#633495",
        "#4e34a2",
        "#3934af",
        "#2534bc",
        "#1134c9",
    ];

    console.log(estadisticas);
    
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-white p-3 rounded border border-1 border-dark d-flex flex-column gap-2 shadow-lg" style={{ maxWidth: "300px" }}>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Dirección:`}</p>
                        <span className=" m-0 fw-semibold ">{`${payload[0].payload.lugar    }`}</span>
                    </div>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Cámara`}</p>
                        <p className=" m-0 fw-semibold">{`${payload[0].payload.numero_serie}`}</p>
                    </div>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Infracciones`}</p>
                        <p className=" m-0 fw-semibold">{`${payload[0].value}`}</p>
                    </div>
                </div>
            );
        }

        return null;
    };

    return (
        <section className=" col-11 mx-auto">
            {/* <h4 className="text-center mb-5">Semáforos con mas infracciones</h4> */}
            <div style={{ height: "550px" }} className=" py-3 ">
                {
                    loads.includes('estadisticas')
                        ?
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                            <MuniSpinner2 />
                        </div>
                        : <ResponsiveContainer width="100%" height={600} /* style={{ overflow: "scroll" }} */>
                            <BarChart data={estadisticas}
                                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis dataKey="numero_serie" />
                                <Tooltip content={<CustomTooltip />} />
                                <Bar
                                    label={{ position: 'top', fill: "#111", fontWeight: "bold" }}
                                    barSize={45}
                                    dataKey="infracciones_count"
                                    isAnimationActive={false}>
                                    {
                                        estadisticas.map((data, index) => {
                                            return (
                                                <Cell cursor="pointer" fill={colors[index]} key={`cell-${index}`} />
                                            )
                                        })
                                    }
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>


                }

            </div>
        </section>
    );
}
export default TopInfracciones;